import { type ContextMenuList } from '../types/context-menu-list.type';
import { hideCenterMarkerMenuItem } from '../menu-item/hide-center-marker-menu-item';

export const centerMarkerMenuList: Array<ContextMenuList> = [
	hideCenterMarkerMenuItem()
];
